"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFailureModes = void 0;
const Predicate_1 = require("effect/Predicate");
const capability_1 = require("../../capability");
const _util_1 = require("../_util");
const getFailureModes = (device) => {
    const [globalFilter1, globalFilter2, globalFilter3, globalFilter4, co2Tank] = device.consumables;
    const alarms = device.alarms.map(({ alarm }) => alarm);
    const enhancements = [co2Tank];
    const filters = [globalFilter1, globalFilter2, globalFilter3, globalFilter4];
    return {
        sanitization: [
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.FirewallFault),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.TankUVCLedFault),
        ],
        dripTrayAndLeak: [
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.LeakBottom),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.DripFull),
        ],
        enhancements: enhancements.filter(Predicate_1.isNotNullable).map(_util_1.getFailureModeSlot),
        heatingStatus: [
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.HotNTC),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.DryHeat),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.HotTankOh),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.HotTankFault),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.HotTankTimeout),
        ],
        chillingStatus: [
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.ColdNTC),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.CompressorFault),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.CompressorTimeout),
        ],
        waterQuality: filters.filter(Predicate_1.isNotNullable).map(_util_1.getFailureModeSlot),
    };
};
exports.getFailureModes = getFailureModes;
//# sourceMappingURL=failure-mode.js.map